// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".experience-item{display:flex;flex-direction:column;position:relative;margin-top:1rem}.experience-item .experience-actions{position:absolute;right:0;top:0}.experience-item .experience-actions a{cursor:pointer}.experience-item .experience-actions i{margin-left:.5rem}.experience-item .description{margin:.3rem 0}.experience-item .location{margin-top:.2rem;color:#9b9b9b}.experience-item .location i{margin-right:2px}", ""]);
// Exports
module.exports = exports;
